const navLinks = [
    { navLinkId: 'Home', scrollToId: 'heroContainer' },
    { navLinkId: 'Services', scrollToId: 'servicesContainer' },
    { navLinkId: 'About', scrollToId: 'aboutContainer' },
    // { navLinkId: 'Contacts', scrollToId: 'contactsContainer' },

];

export default navLinks;
